<template>
  <PageWrapper
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="getAllLessonCategories"
  >
    <template #title> لیست گروه‌بندی درس ها </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateNewLessonCategoryDialog">
        ایجاد گروه‌بندی
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputId="lessonCategoryName"
        inputLabel="جستجو بر اساس نام گروه‌بندی"
        inputPlaceholder="مبتدی"
        v-model.trim="lessonCategoriesFilters.title"
        @enter="getAllLessonCategories"
      ></SearchInput>
      <SearchInput
        inputId="lessonTitle"
        inputLabel="جستجو بر اساس نام درس"
        inputPlaceholder="درس 1 مقدماتی"
        v-model.trim="lessonCategoriesFilters.lessonTitle"
        @enter="getAllLessonCategories"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="lessonCategoriesList"
      :pageNumber="lessonCategoriesFilters.pageNumber"
      :count="lessonCategoriesFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="lessonCategoriesList"
      @changePage="changePage"
    >
      <template #discountPercent="data">
        <div class="w-auto text-center">
          {{
            data.item.discountPercent ? `${data.item.discountPercent} %` : "-"
          }}
        </div>
      </template>
      <!-- فعلا فقط پکیج «از کلمه تا مکالمه» پشتیبانی دارد (needSupport بکند روی پکیج‌های بزرگ‌تر هم خورده) -->
      <template #needSupport="data">
        <b-badge :variant="packageNeedsSupport(data.item) ? 'light-success' : 'light-secondary'">
          {{ packageNeedsSupport(data.item) ? "دارد" : "ندارد" }}
        </b-badge>
      </template>
      <template #isShow="data">
        <BBadge
          class="font-weight-normal"
          :variant="data.item.isShow ? 'success' : 'danger'"
        >
          {{ data.item.isShow ? "فعال" : "غیر فعال" }}
        </BBadge>
      </template>
      <template #actions="data">
        <div class="d-flex align-items-center">
          <BButton
            @click="renderUpdateModal(data.item)"
            variant="transparent"
            size="sm"
          >
            <FeatherIcon icon="EditIcon" size="20" class="text-primary" />
          </BButton>
          <BButton
            @click="renderToggleModal(data.item)"
            variant="transparent"
            size="sm"
          >
            <FeatherIcon
              :icon="data.item.isShow ? 'CheckCircleIcon' : 'SlashIcon'"
              :class="data.item.isShow ? 'text-success' : 'text-danger'"
              size="20"
            />
          </BButton>
          <BButton
            @click="renderDeleteModal(data.item)"
            variant="transparent"
            size="sm"
          >
            <FeatherIcon icon="Trash2Icon" size="20" class="text-danger" />
          </BButton>
        </div>
      </template>
    </CustomTable>
    <CreateLessonCategoryDialog
      @refetch="getAllLessonCategories"
    ></CreateLessonCategoryDialog>
    <UpdateLessonCategoryDialog
      :defaultLessonCategoryId="tempSelectedCategoryId"
      @refetch="getAllLessonCategories"
    ></UpdateLessonCategoryDialog>
    <DeleteLessonCategoryDialog
      :defaultLessonCategoryId="tempSelectedCategoryId"
      @refetch="getAllLessonCategories"
    ></DeleteLessonCategoryDialog>
    <ToggleLessonCategoryDialog
      :defaultLessonCategoryId="tempSelectedCategoryId"
      @refetch="getAllLessonCategories"
    ></ToggleLessonCategoryDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllLessonCategories();
  },
  data() {
    return {
      isLoading: false,
      lessonCategoriesList: null,
      totalCount: null,
      lessonCategoriesFilters: {
        pageNumber: 1,
        count: 10,
        title: null,
        lessonTitle: null,
      },
      tempSelectedCategoryId: null,
      tableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "عنوان گروه‌بندی",
        },
        {
          key: "discountPercent",
          label: "تخفیف گروه‌بندی",
        },
        {
          key: "lessonTitle",
          label: "درس های گروه‌بندی",
        },
        {
          key: "needSupport",
          label: "پشتیبانی تلفنی",
        },
        {
          key: "isShow",
          label: "وضعیت گروه‌بندی",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempSelectedLesson: null,
    };
  },
  methods: {
    packageNeedsSupport,
    renderCreateNewLessonCategoryDialog() {
      this.$bvModal.show("create-lesson-category-dialog");
    },
    renderUpdateModal(lessonCategory) {
      this.tempSelectedCategoryId = lessonCategory.id;
      this.$bvModal.show("update-lesson-category-dialog");
    },
    renderDeleteModal(lessonCategory) {
      this.tempSelectedCategoryId = lessonCategory.id;
      this.$bvModal.show("delete-lesson-category-dialog");
    },
    renderToggleModal(lessonCategory) {
      this.tempSelectedCategoryId = lessonCategory.id;
      this.$bvModal.show("toggle-lesson-category-dialog");
    },
    changePage(pageNumber) {
      this.lessonCategoriesFilters.pageNumber = pageNumber;
      this.getAllLessonCategories();
    },
    async getAllLessonCategories() {
      try {
        this.isLoading = true;
        let _this = this;
        let getLessonCategoriesList = new GetLessonCategoriesList(_this);
        getLessonCategoriesList.setRequestParamDataObj(
          _this.lessonCategoriesFilters
        );
        await getLessonCategoriesList.fetch((res) => {
          _this.lessonCategoriesList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CreateLessonCategoryDialog,
    UpdateLessonCategoryDialog,
    DeleteLessonCategoryDialog,
    ToggleLessonCategoryDialog,
    PageWrapper,
    SearchInput,
    CustomTable,
    BButton,
    BBadge,
  },
};

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CreateLessonCategoryDialog from "@/views/components/LessonCategories/CreateLessonCategoryDialog.vue";
import UpdateLessonCategoryDialog from "@/views/components/LessonCategories/UpdateLessonCategoryDialog.vue";
import DeleteLessonCategoryDialog from "@/views/components/LessonCategories/DeleteLessonCategoryDialog.vue";
import ToggleLessonCategoryDialog from "@/views/components/LessonCategories/ToggleLessonCategoryDialog.vue";
import { BButton, BBadge } from "bootstrap-vue";
import { GetLessonCategoriesList } from "@/libs/Api/LessonCategory";
import { packageNeedsSupport } from "@/views/apps/SupportPackages/supportLessons";
</script>
